// src/hooks/useSessionWatcher.js
import { useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import Context from "../context/AppContext";

export default function useSessionWatcher(idleMinutes = 30) {
  const navigate = useNavigate();
  const { setUser } = useContext(Context);

  const lastActivityRef = useRef(Date.now());
  const idleMs = idleMinutes * 60 * 1000; // 30 min -> ms

  useEffect(() => {
    const handleActivity = () => {
      lastActivityRef.current = Date.now();
    };

    const activityEvents = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
    ];

    activityEvents.forEach((ev) =>
      window.addEventListener(ev, handleActivity)
    );

    const doLogout = (msg) => {
      // swal(msg || "Session expired!");
      swal(msg || "Session expired!");

      sessionStorage.removeItem("user");
      sessionStorage.removeItem("isLogin");
      localStorage.removeItem("token");

      setUser(null);
      navigate("/login", { replace: true });
    };

    const checkSession = () => {
      const savedUser = sessionStorage.getItem("user");
      if (!savedUser || savedUser === "undefined") return;

      let user;
      try {
        user = JSON.parse(savedUser);
      } catch (err) {
        console.error("Invalid user JSON in sessionStorage", err);
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("isLogin");
        localStorage.removeItem("token");
        return;
      }

      const now = Date.now();

      let isExpired = false;
      if (user.exp) {
        isExpired = user.exp * 1000 < now;
      }

      // 🔸 2) Frontend idle time check
      const idleTime = now - lastActivityRef.current;
      const isIdleTooLong = idleTime > idleMs;

      if (isExpired) {
        doLogout("Your session has expired!");
      } else if (isIdleTooLong) {
        doLogout("Your session has expired");
      }
    };

    checkSession();
    const interval = setInterval(checkSession, 15000); // 15s

    return () => {
      activityEvents.forEach((ev) =>
        window.removeEventListener(ev, handleActivity)
      );
      clearInterval(interval);
    };
  }, [idleMs, navigate, setUser]);
}
